<template>
  <div>
    <div class="card">
      <h2>Leaderboard</h2>
      <div class="row">
        <div class="col">
          <label>Juego</label>
          <select class="input" v-model="game">
            <option value="">Todos</option>
            <option v-for="g in games" :key="g.code" :value="g.code">{{ g.name }} ({{ g.code }})</option>
          </select>
        </div>
        <div class="col">
          <label>Desde</label>
          <input class="input" type="date" v-model="from">
        </div>
        <div class="col">
          <label>Hasta</label>
          <input class="input" type="date" v-model="to">
        </div>
        <div class="col" style="align-self:flex-end;">
          <button class="btn" @click="load">Actualizar</button>
        </div>
      </div>
    </div>

    <div class="card">
      <table class="table">
        <thead>
        <tr>
          <th>#</th><th>Jugador</th><th>Torneos</th><th>Ganados</th><th>Puntos totales</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, idx) in rows" :key="row.userId">
          <td>{{ idx + 1 }}</td>
          <td>{{ row.displayName || ('Jugador ' + row.userId) }}</td>
          <td>{{ row.tournamentsPlayed }}</td>
          <td>{{ row.tournamentsWon }}</td>
          <td>{{ row.totalMatchPoints }}</td>
        </tr>
        </tbody>
      </table>
      <p v-if="!rows.length" style="margin-top:8px;">Sin datos en el rango seleccionado.</p>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  data: () => ({ games: [], game: '', from: '', to: '', rows: [] }),
  async created() {
    const g = await api.get('/api/games'); this.games = g.data;
    await this.load();
  },
  methods: {
    async load() {
      const params = {};
      if (this.game) params.game = this.game;
      if (this.from) params.from = this.from;
      if (this.to) params.to = this.to;
      const { data } = await api.get('/api/stats/leaderboard', { params });
      this.rows = data;
    }
  }
}
</script>
